import {Box, Button, Container, Typography} from "@mui/material";
import {Link} from "react-router-dom";

const GetStarted = () => {
    return (
        <Container sx={{my: 10, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>
            <Box component="img" alt="Icon" src="/assets/image/icon/memory-storage.svg" sx={{ width: {xs: 256, lg: 512}, height: {xs: 256, lg: 512}, objectFit: "contain" }}/>
            <Typography variant="h6" fontSize={{xs: "1rem", lg: "1.125rem"}} textAlign="center">به سادگی و بدون نیاز به نصب هیچ نرم افزاری</Typography>
            <Typography mt={1} fontSize={{xs: ".925rem"}} textAlign="center">از تمام فایلهای مهم گوشی و رایانه شخصی خود پشتیبان تهیه کنید و از هر جایی به تمام آنها دسترسی داشته باشید.</Typography>
            <Link to="/drive">
                <Button variant="contained" sx={{ mt: 2, py: 1.75, px: {lg: 16}, width: {xs: "100%", lg: "auto"} }}>شروع کنید</Button>
            </Link>
        </Container>
    )
}
export default GetStarted;